import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Forgot } from "../../../api";
import { useTranslation } from "../../../../context/TranslationContext";

const ForgotStepOtp = ({ phoneNumber, onNext }) => {
  const {
    otpCode: otpLabel,
    verifyCode: verifyBtn,
    resendCode: resendBtn,
    otpError,
    otpResendSuccess,
    otpResendError,
    otpRequired,
    otpLength,
  } = useTranslation();

  const Step2Schema = Yup.object().shape({
    otp: Yup.string().required(otpRequired).length(6, otpLength),
  });

  const handleSubmit = async (values, actions) => {
    try {
      const data = {
        phoneNumber: phoneNumber,
        otp: values.otp,
      };
      const response = await Forgot(data, 2);
      if (response.data.error) {
        toast.error(response.data.error);
      } else {
        onNext(response.data.token);
      }
    } catch (error) {
      toast.error(otpError);
    } finally {
      actions.setSubmitting(false);
    }
  };

  const handleResend = async () => {
    try {
      const response = await Forgot({ phoneNumber: phoneNumber }, 1);
      if (response.data.error) {
        toast.error(response.data.error);
      } else {
        toast.success(otpResendSuccess);
      }
    } catch (error) {
      toast.error(otpResendError);
    }
  };

  return (
    <Formik
      initialValues={{ otp: "" }}
      validationSchema={Step2Schema}
      onSubmit={handleSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <div className="relative z-0 mb-6 w-full group">
            <input
              type="text"
              id="otp"
              name="otp"
              className="block rounded-md py-5 px-6 w-full text-[0.875rem] bg-transparent border border-[#dee9ed] appearance-none focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
              placeholder=" "
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              value={props.values.otp}
            />
            <label
              htmlFor="otp"
              className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
            >
              {otpLabel}
            </label>
            {props.errors.otp && props.touched.otp && (
              <span className="text-xs text-red-500 mt-1">
                {props.errors.otp}
              </span>
            )}
          </div>
          <button
            disabled={props.isSubmitting || !props.isValid || !props.dirty}
            type="submit"
            className="w-full text-white px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm disabled:opacity-60 mb-5"
          >
            {verifyBtn}
          </button>
          <div className="flex justify-center">
            <button
              type="button"
              onClick={handleResend}
              className="text-sm font-semibold text-product-type-color hover:underline mb-5"
            >
              {resendBtn}
            </button>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default ForgotStepOtp;
